require("@rails/ujs").start()
require("channels")

// js
import 'datatables.net-bs4'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'admin-lte/dist/js/adminlte'
import '@fortawesome/fontawesome-free/js/all.min'
// import 'admin-lte/plugins/select2/select2.full.min'
import 'select2/dist/js/select2.min'
import 'trumbowyg/dist/trumbowyg.min'
import 'trumbowyg/dist/plugins/base64/trumbowyg.base64.min'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min'
import 'pc-bootstrap4-datetimepicker/build/js/bootstrap-datetimepicker.min'
import 'jquery.repeater/jquery.repeater.min'
import 'jquery-balloon-js/jquery.balloon.min'
import 'jquery.autokana/jquery.autoKana'

// original
import '../src/users/common/popup_form_service/main'
import '../src/users/common/simple_popup_service/main'
import '../src/users/common/global_scope/main'
import '../src/users/common/init_service/main'

// js
import '../src/users/main'
import '../src/users/init_service/main'

// css
import '../src/users/common/main.scss'
import '../src/users/common/simple_popup_service/simple_popup_service'

// css
import '../src/users/main.scss'